import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  EVENTS_LOAD_PROJECT_PLUGINS_BEGIN,
  EVENTS_LOAD_PROJECT_PLUGINS_SUCCESS,
  EVENTS_LOAD_PROJECT_PLUGINS_FAILURE,
  EVENTS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR,
} from './constants';

export function loadProjectPlugins(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_LOAD_PROJECT_PLUGINS_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_LOAD_PROJECT_PLUGINS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EVENTS_LOAD_PROJECT_PLUGINS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectPluginsError() {
  return {
    type: EVENTS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_LOAD_PROJECT_PLUGINS_BEGIN:
      return {
        ...state,
        loadProjectPluginsPending: true,
        loadProjectPluginsError: null,
      };

    case EVENTS_LOAD_PROJECT_PLUGINS_SUCCESS:
      return {
        ...state,
        loadProjectPluginsPending: false,
        loadProjectPluginsError: null,
        plugins: action.data || [],
      };

    case EVENTS_LOAD_PROJECT_PLUGINS_FAILURE:
      return {
        ...state,
        loadProjectPluginsPending: false,
        loadProjectPluginsError: action.data.error,
      };

    case EVENTS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR:
      return {
        ...state,
        loadProjectPluginsError: null,
      };

    default:
      return state;
  }
}
